module.exports = __webpack_public_path__ + "static/media/residential-apartment.ae1a9449.svg";